import {
    Grid,
    Typography,
    WithStyles,
    withStyles,
    Paper,
  } from "@material-ui/core";
  import React, { Component, ReactNode } from "react";
  import { connect } from "react-redux";
import { userStyles } from "../userManagement/styles";
  
  interface AccessDeniedProps extends WithStyles<typeof userStyles> {
    imageURL: string,
    heading: string,
    subPara: string;
    htmlElement: ReactNode;
  }
  
  class AccessDenied extends Component<AccessDeniedProps> {
    constructor(props:AccessDeniedProps){
		super(props);
    }  

    render() {
        const { imageURL, heading, subPara, classes, htmlElement } = this.props;
        
        return(
        <>
         <Paper elevation={0} classes={{root: classes.accessDeniedRoot}}>
        <Grid className={classes.paddingSM}>
        <Grid container justify="flex-start">
            <Grid item>
            {/* <img className={classes.marginTopSM} width="100" height="60" src="/assets/svg/mypat-logo.svg" alt="favorite" /> */}
            </Grid>
        </Grid>
         <Grid container className={[classes.paddingSM, classes.MyPATNoDataPanel].join(' ')} 
         justify="center" alignItems="center" direction="column">
            <Grid item>
                <img width="200" height="204" src={imageURL} alt="favorite" />
            </Grid>

            <Grid item>
                <Typography className={[classes.black, 
                    classes.fontWeight_MD,
                    classes.fontSize24].join(' ')}>{heading}</Typography>
            </Grid>

            <Grid item>
                <Typography className={[classes.grey, 
                    classes.fontWeight_SM, 
                    classes.marginTopSM,
                    classes.fontSize_SM].join(' ')}>{subPara}</Typography>
            </Grid>

            <Grid item>
               {htmlElement}
            </Grid>
        </Grid>
        </Grid>
        </Paper>
        </>);
    }
  }

  // @ts-ignore
  export default connect()(withStyles(userStyles)(AccessDenied));